import { getAPI } from 'src/utils/api';
import checkAuthError from '../utils/checkAuthError';

const getObjectData = async (modelId, guid) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/iemclass/single/${guid}`);

		return data;
	} catch (error) {
		checkAuthError(error);
		const message = error?.response?.data?.message || 'Failed to fetch object data';
		console.error(message, error);
		throw new Error(message);
	}
};

const getAllObjectListAttributes = async (modelId, revision) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(
			`model/${modelId}/iemclass/allListAttributes/?query=${JSON.stringify({ revision })}`
		);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('Couldnt get all list attributes', error);
		return { listAttributes: [] };
	}
};

const getListAttributesOfObject = async (modelId, guid, revision) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(
			`model/${modelId}/iemclass/allListAttributes/?query=${JSON.stringify({ revision, guid })}`
		);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('Couldnt get all list attributes', error);
		return { listAttributes: [] };
	}
};

const getAllObjectReferenceAttributes = async (modelId, revision = '') => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/iemclass/allReferenceAttributes?revision=${revision}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('getAllObjectReferenceAttributes', error);
		return { referenceAttributes: [] };
	}
};

const getObjectById = async (modelId, id, revision = '') => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/iemclass/byId/?id=${id}&revision=${revision}`);
		return data;
	} catch (error) {
		checkAuthError(error);

		console.error('Couldnt get object by id', error);
		return { object: null };
	}
};

const getInputOutputObjectData = async (modelId, guid, revision) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/iemclass/inOutput/$?guid=${guid}&revision=${revision}`);

		return data;
	} catch (error) {
		checkAuthError(error);

		if (error.response.data.message) {
			console.error(error.response.data.message);
			throw new Error(error.response.data.message);
		} else {
			console.error(error);
			throw error;
		}
	}
};

const getProductsForProductPass = async (modelId, viewId, revision, checkParState) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(
			`model/${modelId}/iemclass/getProductsForProductPass/$?viewId=${viewId}&revision=${revision}&checkParState=${checkParState}`,
			{
				timeout: 60000,
			}
		);

		if (!data) {
			throw new Error('No data received from server');
		}

		return data;
	} catch (error) {
		checkAuthError(error);
		const message = error?.response?.data?.message || 'Failed to fetch products for product pass';
		console.error(message, error);
		throw new Error(message);
	}
};

const getInputsOfOutputProgress = async (modelId) => {
	try {
		const api = await getAPI();
		const { data } = await api.get(`model/${modelId}/iemclass/inputsOfOutputProgress`, { timeout: 60000 });

		return data;
	} catch (error) {
		checkAuthError(error);

		if (error.response.data.message) {
			console.error(error.response.data.message);
			throw new Error(error.response.data.message);
		} else {
			console.error(error);
			throw error;
		}
	}
};

export {
	getObjectData,
	getAllObjectListAttributes,
	getAllObjectReferenceAttributes,
	getObjectById,
	getInputOutputObjectData,
	getProductsForProductPass,
	getInputsOfOutputProgress,
	getListAttributesOfObject,
};
